














import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import CInternationalTelephoneInput from '~/components/shared/configurable/form/input/CInternationalTelephoneInput.vue'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { computeFieldState } from '~/utils/form'

export default defineComponent({
  components: { CFormError, CInternationalTelephoneInput },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name } = toRefs(props)
    const { value, error, changeValue } = useDynamicForm(props)

    const inputState = computed(() => computeFieldState(error.value))

    function handleTelephoneInput(telephone: any) {
      error.value = null
      changeValue(name.value, telephone)
    }

    return { value, error, inputState, handleTelephoneInput }
  }
})
